import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Settings";
import Auth from "./Auth";
import Common from "./Common";
import DisableButton from "./DisableButton";
import CreateOrder from "./CreateOrder";
import ActiveTab from "./ActiveTab";
import BankAccount from "./BankAccount";
import Website from "./Website";
import EntityPayment from "./EntityPayment";
import PaymentGateway from "./PaymentGateway";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    auth: Auth,
    common: Common,
    button: DisableButton,
    manuallyOrder: CreateOrder,
    activeTab: ActiveTab,
    bankAccount: BankAccount,
    website: Website,
    entityPayment: EntityPayment,
    paymentGateway: PaymentGateway,
  });

export default createRootReducer;
